import http from "../http-common";
const getAll = () => {
  return http.get("/vehicles");
};
const getAllActiveVehicles = () => {
  return http.get("/vehicles/active")
};
const updateVehicles = (id, data) => {
  return http.put(`/vehicles/${id}`, data)
};
const createNewVehicles = (data) => {
	return http.post('/vehicles', data);
};
const deleteVehicles = (id, data) => {
  return http.delete(`/vehicles/${id}`);
};
const getVehicle = (id) => {
  return http.get(`/vehicles/${id}`);
};

const exportRepairMaintenanceReport = (vehicleId) => {
  return http.get(`/vehicles/${vehicleId}/export-repair-maintenance-report`, {
    responseType: 'blob'
  });
};

const exportMonthlyMaintenanceForm = (month, year) => {
  return http.get('/vehicles/export-monthly-maintenance-form', {
    params: { month, year },
    responseType: 'blob'
  });
};

const exportYearlyMaintenanceForm = (year) => {
  return http.get('/vehicles/export-yearly-maintenance-form', {
    params: { year },
    responseType: 'blob'
  });
};

const exportCacfp = (year) => {
  return http.get('/vehicles/export-cacfp', {
    params: { year },
    responseType: 'blob'
  });
};

const getCacfpData = (year) => {
  return http.get('/vehicles/cacfp-data', {
    params: { year },
  });
};

const exportAllVehicleReport = () => {
  return http.get('/vehicles/export-all-vehicle-report', {
    responseType: 'blob'
  });
};

const exportAllRepairMaintenanceReports = () => {
  return http.get('/vehicles/export-all-repair-maintenance-reports', {
    responseType: 'blob'
  });
};

const convertToDate = (dateString) => {
  const [month, day, year] = dateString.split('/');
  return new Date(Number(year), Number(month)-1, Number(day))
}

/**
 * Physical file upload to /files/upload-physical (multer .single("file")).
 * The default axios "Content-type: application/json" breaks FormData: the body is not
 * parsed as multipart, so req.file is empty. Strip Content-Type for FormData so the
 * browser/axios can set multipart/form-data with a boundary.
 */
const uploadVechileFile = (data, vehicleId, name, fileType, date) => {
  const objectIdQ = encodeURIComponent(String(vehicleId));
  const nameQ = encodeURIComponent(String(name));
  const fileTypeQ = encodeURIComponent(String(fileType));
  const ts = date && typeof date.getTime === "function" ? date.getTime() : Date.now();
  const url = `/files/upload-physical?objectId=${objectIdQ}&name=${nameQ}&fileType=${fileTypeQ}&model=vehicle&date=${ts}`;
  if (!(data instanceof FormData)) {
    return http.post(url, data);
  }
  return http.post(url, data, {
    transformRequest: [
      (payload, h) => {
        if (payload instanceof FormData && h && typeof h === "object") {
          delete h["Content-Type"];
          delete h["content-type"];
          delete h["Content-type"];
        }
        return payload;
      },
    ],
  });
};

/**
 * Files served at /files/... (see server express.static on upload dir). API base is .../api.
 */
const getPhysicalFileDownloadUrl = (fileUrl) => {
  if (!fileUrl) return '';
  const base = (http && http.defaults && http.defaults.baseURL) || '';
  return String(base).replace(/\/api\/?$/, '') + fileUrl;
};

/**
 * Repair uploads are stored as: {repairId}_{vehicleId}_repair_{ts}.ext
 * The API returns all files under vehicle/{vehicleId}/repair/; group by first path segment.
 */
const indexRepairReceiptFiles = (files) => {
  const byId = {};
  (files || []).forEach((f) => {
    const fn = f && f.name;
    if (!fn || typeof fn !== 'string') return;
    const repairId = fn.split('_')[0];
    if (!repairId) return;
    if (!byId[repairId]) byId[repairId] = [];
    byId[repairId].push(f);
  });
  Object.keys(byId).forEach((k) => {
    byId[k].sort(
      (a, b) =>
        new Date(b && b.modifiedAt) - new Date(a && a.modifiedAt)
    );
  });
  return byId;
};

const getAllVechileFiles = (vehicleId, name, fileType) => {
  const safeName = encodeURIComponent(String(name ?? ''));
  const id = encodeURIComponent(String(vehicleId ?? ''));
  const ft = encodeURIComponent(String(fileType ?? ''));
  return http.get(`/files/uploadedDocs/vehicle/${id}/type/${ft}/name/${safeName}`);
};

const deleteVechileFile = (vehicleId, fileType, fileName) => {
  return http.post('/files/delete-physical', {
    model: 'vehicle',
    objectId: vehicleId,
    fileType,
    fileName
  });
}

export const VehicleService = {
  getAll,
  getAllActiveVehicles,
  updateVehicles,
  createNewVehicles,
  deleteVehicles,
  getVehicle,
  exportRepairMaintenanceReport,
  exportMonthlyMaintenanceForm,
  exportYearlyMaintenanceForm,
  exportCacfp,
  getCacfpData,
  exportAllVehicleReport,
  exportAllRepairMaintenanceReports,
  convertToDate,
  uploadVechileFile,
  getPhysicalFileDownloadUrl,
  indexRepairReceiptFiles,
  getAllVechileFiles,
  deleteVechileFile
};
